var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"rounded-circle",attrs:{"src":_vm.src,"aspect-ratio":"1/1","contain":"","height":_vm.size,"max-width":_vm.size,"width":_vm.size}},[_c('img',{attrs:{"slot":"placeholder","src":_vm.fallbackImage,"alt":"logo"},slot:"placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }